module.exports = __webpack_public_path__ + "files/2c60cccfd1ba82b468fe8d10db132492.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/droidserif-bolditalic-webfont.eot
 ** module id = 402
 ** module chunks = 0
 **/